let mermaidReady = false;

async function ensureMermaid() {
  const mermaid = (await import('mermaid')).default;
  if (!mermaidReady) {
    mermaid.initialize({
      startOnLoad: false,
      theme: 'neutral',
      securityLevel: 'strict',
    });
    mermaidReady = true;
  }
  return mermaid;
}

export function useDocsMermaid(containerRef: Ref<HTMLElement | null>, contentKey: MaybeRefOrGetter<string>) {
  async function renderMermaid() {
    if (!import.meta.client) {
      return;
    }

    await nextTick();

    const container = containerRef.value;
    if (!container) {
      return;
    }

    const nodes = container.querySelectorAll<HTMLElement>('.mermaid');
    if (!nodes.length) {
      return;
    }

    try {
      const mermaid = await ensureMermaid();
      await mermaid.run({ nodes: Array.from(nodes) });
    } catch (error) {
      console.error('[docs] Failed to render mermaid diagram:', error);
    }
  }

  watch(
    () => toValue(contentKey),
    () => {
      void renderMermaid();
    },
    { flush: 'post' },
  );

  onMounted(() => {
    void renderMermaid();
  });
}
